<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-form-item label="状态:"> 
                        <el-select v-model="table.where.status" filterable placeholder="请选择">
                            <el-option label=" 待付款" value="1"></el-option>
                            <el-option label="待确认" value="2"></el-option>
                            <el-option label="待发货" value="3"></el-option>
                            <el-option label="发货中" value="4"></el-option>
                            <el-option label="已完成" value="5"></el-option>
                            <el-option label="申请退款" value="7"></el-option>
                            <el-option label="申请退货" value="8"></el-option>
                            <el-option label="退款/货" value="9"></el-option>
                            <el-option label="退款/货完成" value="10"></el-option>
                            <el-option label="取消订单" value="11"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="创建时间:">
                        <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="发货时间:">
                        <el-input-number v-model="table.where.consignment_time" placeholder="请输入发货时间" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="用户:">
                        <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支付方式:">
                        <el-select v-model="table.where.type_payment" filterable placeholder="请选择">
                            <el-option label="微信" value="1"></el-option>
                            <!-- <el-option label="2=小程序3支付宝" value="23"></el-option> -->
                        </el-select>
                    </el-form-item>

                    <el-form-item label="订单号:">
                        <el-input v-model="table.where.out_pay_num" placeholder="请输入订单号" clearable />
                    </el-form-item>

                    <!-- <el-form-item label="商铺ID:">
                        <el-select v-model="table.where.shop_id" filterable placeholder="请选择">

                            <el-option v-for="item in store_shop_management_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->

                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:storegoodsorder:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->

            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-restore"
                    class="ele-btn-icon" size="small">刷新
                </el-button>
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoodsorder:add')">添加
                </el-button>
               
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
                    
                <el-button :type="table.where.status == 2?'primary':'info'" size="small"  @click="(table.where.status = 2)&&$refs.table.reload()">待发货</el-button>
                <el-button :type="table.where.status == 3?'primary':'info'" size="small"  @click="(table.where.status = 3)&&$refs.table.reload()">已发货</el-button>
                <el-button :type="table.where.status == 4?'primary':'info'" size="small" @click="(table.where.status = 4)&&$refs.table.reload()">已完成</el-button>
                <el-button :type="table.where.status == 1?'primary':'info'" size="small" @click="(table.where.status = 1)&&$refs.table.reload()">待付款</el-button>
                <el-button :type="table.where.status == 7?'primary':'info'" size="small" @click="(table.where.status = 7)&&$refs.table.reload()">退款申请</el-button>
                <el-button :type="table.where.status == 10?'primary':'info'" size="small" @click="(table.where.status = 10)&&$refs.table.reload()">退款完成</el-button>
                <el-button :type="table.where.status==''?'primary':'info'" size="small" @click="(table.where.status = '')&&$refs.table.reload()">全部</el-button>
            </div>

            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />

<el-table-column prop="out_pay_num" label="订单号" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.status == 1" :key="index"> 待付款</el-tag>
                            <el-tag v-if="row.status == 2" :key="index">待确认</el-tag>
                            <el-tag v-if="row.status == 3" :key="index">待发货</el-tag>
                            <el-tag v-if="row.status == 4" :key="index">发货中</el-tag>
                            <el-tag v-if="row.status == 5" :key="index">已完成</el-tag>
                            <el-tag v-if="row.status == 7" :key="index">申请退款</el-tag>
                            <el-tag v-if="row.status == 8" :key="index">申请退货</el-tag>
                            <el-tag v-if="row.status == 9" :key="index">退款/货</el-tag>
                            <el-tag v-if="row.status == 10" :key="index">退款/货完成</el-tag>
                            <el-tag v-if="row.status == 11" :key="index">取消订单</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activity_status" label="订单类型" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.activity_status == 0" :key="index"> 普通商品</el-tag>
                            <el-tag v-if="row.activity_status == 1" :key="index">秒杀</el-tag>
                            <el-tag v-if="row.activity_status == 2" :key="index">折上折</el-tag>
                            <el-tag v-if="row.activity_status == 3" :key="index">团购</el-tag>
                            <el-tag v-if="row.activity_status == 4" :key="index">免单</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="total_price" label="支付金额" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="num" label="总数量" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="consignment_time" label="发货时间" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="user_id" label="用户" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.user_id_info" :key="index">{{item.nick_name+item.phone}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="type_payment" label="支付方式" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.type_payment == 1" :key="index">微信</el-tag>
                            <el-tag v-if="row.type_payment == 3" :key="index">支付宝</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="address_id" label="发货地址" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <div v-for="(item,index) in row.address_id_info" :key="index">
                                <el-tag :key="index">{{item.name}}-{{item.phone}}</el-tag>
                                <br />
                                <el-tag :key="index">{{item.address}}{{item.house_num}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>

 <el-table-column prop="waybill_number" label="运单号" sortable="custom" show-overflow-tooltip
                        min-width="120" />
                    


                    <!-- <el-table-column prop="shop_id" label="商铺ID" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.shop_id_info" :key="index">{{item.name}}</el-tag>
                        </template>
                    </el-table-column> -->



                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:storegoodsorder:edit')">详细信息</el-link>
                                <el-link @click="wuliu(row)" icon="el-icon-box" type="danger" :underline="false"
                                    v-if="permission.includes('sys:storegoodsorder:edit') && row.status == 3">物流详情</el-link>
                            <!-- <el-popconfirm v-if="row.status == 2" title="确定要发货吗？" @confirm="deliverGoodsShow(row,'status',3)" class="ele-action"> -->
                                <el-link slot="reference" icon="el-icon-box" type="danger" :underline="false"
                                    @click="deliverGoodsShow(row)" v-if="permission.includes('sys:storegoodsorder:delete')&& row.status == 2">发货</el-link>
                            <!-- </el-popconfirm> -->
                            <el-popconfirm v-if="row.status == 7||row.status == 8||row.status == 9" title="确定要退款吗？" @confirm="editRefund(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-box" type="danger" :underline="false"
                                    v-if="permission.includes('sys:storegoodsorder:delete')">退款</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog title="详情信息" :visible.sync="showEdit" width="800px" :destroy-on-close="true" :lock-scroll="false"
            @close="closeDialog" :close-on-click-modal="false">
            <template>
                <el-table :data="editForm.goods_info" border style="width: 100%">
                    <el-table-column prop="thumbnail_pic" label="商品图片" width="180">
                        <template slot-scope="{row}">
                            <el-image style="width: 50px; height: 50px" :src="row.thumbnail_pic"
                                :preview-src-list="[row.thumbnail_pic]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="商品名称" width="180">
                    </el-table-column>
                    <el-table-column prop="format_info" label="规格信息">
                        <template slot-scope="{row}">
                            <div v-if="row.format_info">
                                <div v-for="(item,index) in row.format_info.info" :key="index">
                                    <el-tag :key="index">{{item}}</el-tag>
                                </div>
                            </div>
                            <div v-else>
                                默认规格
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="num" label="购买数量">
                    </el-table-column>
                    <el-table-column prop="price" label="价格">
                    </el-table-column>
                   
                </el-table>
            </template>

            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="物流信息" :visible.sync="wuliushowEdit" width="800px" :destroy-on-close="true" :lock-scroll="false"
            @close="closeDialog" :close-on-click-modal="false">
            <template>
               <el-timeline-item v-for="(item,index) in wuliu_info.path_item_list" :key="index" :timestamp="item.action_time" placement="top">
                    <el-card>
                      <h4 v-if="item.action_type == 100001">揽件阶段-揽件成功</h4>
                      <h4 v-if="item.action_type == 100002">揽件阶段-揽件失败</h4>
                      <h4 v-if="item.action_type == 100003">揽件阶段-分配业务员</h4>
                      <h4 v-if="item.action_type == 200001">运输阶段-更新运输轨迹</h4>
                      <h4 v-if="item.action_type == 300002">派送阶段-开始派送</h4>
                      <h4 v-if="item.action_type == 300003">派送阶段-签收成功</h4>
                      <h4 v-if="item.action_type == 300004">派送阶段-签收失败</h4>
                      <h4 v-if="item.action_type == 400001">异常阶段-订单取消</h4>
                      <h4 v-if="item.action_type == 400002">异常阶段-订单滞留</h4>
                      <p>{{item.action_msg}}</p>
                    </el-card>
                  </el-timeline-item>
            </template>
       
            <div slot="footer">
                <el-button @click="wuliushowEdit=false">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="快递信息" :visible.sync="fahuoShowEdit" width="800px" :destroy-on-close="true" :lock-scroll="false"
            @close="closeDialog" :close-on-click-modal="false">
            <template>
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
               <el-form-item label="物流信息:" prop="delivery_id">
                   <el-select v-model="editFormfahuo.delivery_id" filterable placeholder="请选择物流信息">
                       <el-option v-for="(item,index) in logistics_fare_class" :key="index" :label="item.title" :value="item.id"></el-option>
                   </el-select>
               </el-form-item>
               </el-form>
            </template>
               
            <div slot="footer">
                <el-button @click="fahuoShowEdit=false">取消</el-button>
                <el-button type="primary" @click="deliverGoods">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";


    export default {
        name: "SysStoreGoodsOrder",
        components: {
        },
        data() {
            return {
                editFormfahuo:{
                    delivery_id:'',
                },
                fahuoShowEdit:false,
                wuliu_info:{},
                wuliushowEdit:false,
                table: {
                    url: '/store/StoreGoodsOrder/index',
                    where: {
                        "image": [],
                        status:2,
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    "image": []
                }, // 表单数据
                editFormTemp: {
                    "image": []
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                user_openinfo_list: [],
                user_address_list: [],
                store_shop_management_list: [],
                logistics_fare_class:[],
                editRules: { // 表单验证规则
                    delivery_id:[{
                        required: true,
                        message: '请选择物流',
                        trigger: 'blur'
                    }],
                    out_trade_no: [{
                        required: true,
                        message: '请输入商户订单号',
                        trigger: 'blur'
                    }],


                    out_refund_no: [{
                        required: true,
                        message: '请输入商户退款单号',
                        trigger: 'blur'
                    }],


                    status: [{
                        required: true,
                        message: '请选择状态',
                        trigger: 'blur'
                    }],


                    total_price: [{
                        required: true,
                        message: '请输入支付金额',
                        trigger: 'blur'
                    }],


                    num: [{
                        required: true,
                        message: '请输入总数量',
                        trigger: 'blur'
                    }],


                    create_time: [{
                        required: true,
                        message: '请选择创建时间',
                        trigger: 'blur'
                    }],


                    consignment_time: [{
                        required: true,
                        message: '请输入发货时间',
                        trigger: 'blur'
                    }],


                    user_id: [{
                        required: true,
                        message: '请选择用户',
                        trigger: 'blur'
                    }],


                    type_payment: [{
                        required: true,
                        message: '请选择支付方式',
                        trigger: 'blur'
                    }],


                    remake: [{
                        required: true,
                        message: '请输入备注',
                        trigger: 'blur'
                    }],


                    transaction_id: [{
                        required: true,
                        message: '请选择微信支付订单号	',
                        trigger: 'blur'
                    }],


                    refund_price: [{
                        required: true,
                        message: '请输入退款金额',
                        trigger: 'blur'
                    }],


                    refund_num: [{
                        required: true,
                        message: '请输入退货数量',
                        trigger: 'blur'
                    }],


                    description: [{
                        required: true,
                        message: '请输入描述',
                        trigger: 'blur'
                    }],


                    refund_description: [{
                        required: true,
                        message: '请输入退款描述',
                        trigger: 'blur'
                    }],


                    image: [{
                        required: true,
                        message: '请上传上传需求图片',
                        trigger: 'blur'
                    }],


                    address_id: [{
                        required: true,
                        message: '请选择发货地址id',
                        trigger: 'blur'
                    }],


                    out_pay_num: [{
                        required: true,
                        message: '请输入订单号',
                        trigger: 'blur'
                    }],


                    refund_dh: [{
                        required: true,
                        message: '请输入退货单号',
                        trigger: 'blur'
                    }],


                    shop_id: [{
                        required: true,
                        message: '请选择商铺ID',
                        trigger: 'blur'
                    }],


                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {

            this.userAllList();
            this.UserOpeninfoAllList();
            this.UserAddressAllList();
            this.StoreShopManagementAllList();
            this.logisticsFareClass();
            
            
        },
        methods: {
            /**
              * 退款
              * */
            editRefund(row){
                this.$http.get('/store/StoreGoodsOrder/editRefund?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.$message.success('退款成功');
                        this.$refs.table.reload();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/store/StoreGoodsOrder/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/store/StoreGoodsOrder/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            wuliu(row){
                const loading = this.$loading({
                    lock: true
                });
                this.$http.post('/store/StoreGoodsOrder/wuliu',{out_pay_num:row.out_pay_num}).then(res => {
                    if (res.data.code === 0) {
                        loading.close();
                        this.wuliushowEdit = true;
                        setTimeout(() => {
                            this.wuliu_info = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的订单记录吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/store/StoreGoodsOrder/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/store/StoreGoodsOrder/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 获取全部会员 */
            userAllList() {
                this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /* 导出数据Excel */
            exportExcel() {
                let ids  = this.choose.map(d => d.id)
                if(ids.length == 0){
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {id:ids})
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            //查询其他信息
            UserOpeninfoAllList() {
                this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_openinfo_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            UserAddressAllList() {
                this.$http.post('/user/UserAddress/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_address_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            StoreShopManagementAllList() {
                this.$http.post('/store/StoreShopManagement/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.store_shop_management_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            logisticsFareClass() {
                this.$http.post('/logistics/LogisticsFareClass/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.logistics_fare_class = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            deliverGoodsShow(row){
                this.editFormfahuo.id = row.id;
                this.fahuoShowEdit = true;
            },
            deliverGoods(){
                const loading = this.$loading({
                    lock: true
                });
                this.$http.post("/store/StoreGoodsOrder/deliverGoods", this.editFormfahuo).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.fahuoShowEdit = false;
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                        this.$refs.table.reload();
                    } else {
                        // row[name] = !row[name] ? 1 : 0;
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
            /**
             * 更改状态
             */
            editStatus(row, name, value) {
                const loading = this.$loading({
                    lock: true
                });
                let data = {
                    id: row.id,
                    name: name,
                    value: value,
                }
                this.$http.post("/store/StoreGoodsOrder/status", data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                        this.$refs.table.reload();
                    } else {
                        // row[name] = !row[name] ? 1 : 0;
                        this.$message.error(res.data.msg);

                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },

        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
